import * as React from 'react';
import './FingeringIndicator.css';
import FingeringText from './FingeringText';
import { Fade } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
const FingeringIndicator = (props) => {
    const theme = useTheme();
    const darkTheme = theme.palette.type === 'dark';
    return (React.createElement(Fade, { in: true },
        React.createElement("div", { className: 'hands-container' },
            React.createElement("div", { className: darkTheme ? 'hands-dark' : 'hands' },
                props.showWord ?
                    React.createElement(FingeringText, { fingeringObject: props.fingeringObject })
                    :
                        '',
                props.fingeringObject.fingerSet.map((finger, index) => (React.createElement("div", { key: index, className: 'finger f' + finger + (darkTheme ? ' finger-dark' : '') })))))));
};
export default FingeringIndicator;
//# sourceMappingURL=FingeringIndicator.js.map